import React, { useEffect, useState } from 'react'

interface Props {
  isLoading?: boolean
  style?: React.CSSProperties
}

const Loader = ({ isLoading = false, style }: Props): JSX.Element => {
  const [isVisible, setIsVisible] = useState(isLoading)

  useEffect(() => {
    if (isLoading) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }, [isLoading])

  if (!isVisible) {
    return <></>
  }

  return (
    <>
      <div className="bigLoader w-[22px] h-[22px] flex justify-center items-center rounded-4" style={style}>
        <div className="smallLoader w-[8px] h-[8px] rounded-4" />
      </div>

      <style>{`
        .bigLoader {
          border: 4px solid rgba(255, 255, 255, 0.2);
          border-top-color: white;
          animation: spin 1.5s linear infinite;
        }

        .smallLoader {
          border: 4px solid rgba(255, 255, 255, 0.2);
          border-top-color: white;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </>
  )
}

export default Loader
